// reducers/authReducer.js
import {
  CLEAR_AUTH,
  LOGIN_FAILURE,
  SET_TOKEN,
  SET_USER,
} from "../actions/actionTypes"

const initialState = {
  token: null,
  userList: null,
}


export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
        error: undefined,
      };
    case SET_USER:
      return {
        ...state,
        userList: action.payload,
      };
    case CLEAR_AUTH:
      return {
        ...state,
        token: null,
        userList: null,
      };
      case LOGIN_FAILURE:
      return {
        ...state,
        token: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
